import DocumentsList from './DocumentsList';

export const RepresentativeStudentDocumentList = () => {
  return <DocumentsList containsCollaborationFiles={false} />;
};
